
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {SortingEnum} from './SortingEnum';
import {FieldModelSortingEnum} from './SortingEnum';
import {Sorting} from './Sorting';
import {FieldModelSorting} from './Sorting';

/**
 * SocialTradingMasterAccountSorting struct
 */
class SocialTradingMasterAccountSorting {
  /**
   * Initialize struct
   * @param {SortingEnum=} allocationMethod
   * @param {SortingEnum=} accountMode
   * @param {Sorting=} commissionLogin
   * @param {Sorting=} feePercent
   * @constructor
   */
  constructor (allocationMethod = null, accountMode = null, commissionLogin = null, feePercent = null) {
    this.AllocationMethod = allocationMethod
    this.AccountMode = accountMode
    this.CommissionLogin = commissionLogin
    this.FeePercent = feePercent
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingMasterAccountSorting}
   * @param {!SocialTradingMasterAccountSorting} other Other struct
   * @returns {!SocialTradingMasterAccountSorting} This struct
   */
  copy (other) {
    if (other.AllocationMethod != null) {
      this.AllocationMethod = SortingEnum.fromObject(other.AllocationMethod)
    } else {
      this.AllocationMethod = null
    }
    if (other.AccountMode != null) {
      this.AccountMode = SortingEnum.fromObject(other.AccountMode)
    } else {
      this.AccountMode = null
    }
    if (other.CommissionLogin != null) {
      this.CommissionLogin = Sorting.fromObject(other.CommissionLogin)
    } else {
      this.CommissionLogin = null
    }
    if (other.FeePercent != null) {
      this.FeePercent = Sorting.fromObject(other.FeePercent)
    } else {
      this.FeePercent = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingMasterAccountSorting}
   * @returns {!SocialTradingMasterAccountSorting} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingMasterAccountSortingModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingMasterAccountSortingModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingMasterAccountSorting}
   * @param {!SocialTradingMasterAccountSorting} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingMasterAccountSorting)) {
      throw new TypeError('Instance of SocialTradingMasterAccountSorting is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingMasterAccountSorting}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      AllocationMethod: ((this.AllocationMethod != null) ? this.AllocationMethod : null),
      AccountMode: ((this.AccountMode != null) ? this.AccountMode : null),
      CommissionLogin: ((this.CommissionLogin != null) ? this.CommissionLogin : null),
      FeePercent: ((this.FeePercent != null) ? this.FeePercent : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingMasterAccountSorting.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingMasterAccountSorting} other Object value
   * @returns {!SocialTradingMasterAccountSorting} Created struct
   */
  static fromObject (other) {
    return new SocialTradingMasterAccountSorting().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingMasterAccountSorting}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingMasterAccountSorting.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingMasterAccountSorting}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 164
  }
}

export { SocialTradingMasterAccountSorting };

/**
 * Fast Binary Encoding SocialTradingMasterAccountSorting field model
 */
class FieldModelSocialTradingMasterAccountSorting extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.AllocationMethod = new fbe.FieldModelOptional(new FieldModelSortingEnum(buffer, 4 + 4), buffer, 4 + 4)
    this.AccountMode = new fbe.FieldModelOptional(new FieldModelSortingEnum(buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize), buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize)
    this.CommissionLogin = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.AccountMode.fbeOffset + this.AccountMode.fbeSize), buffer, this.AccountMode.fbeOffset + this.AccountMode.fbeSize)
    this.FeePercent = new fbe.FieldModelOptional(new FieldModelSorting(buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize), buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.AllocationMethod.fbeSize + this.AccountMode.fbeSize + this.CommissionLogin.fbeSize + this.FeePercent.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.AllocationMethod.fbeExtra + this.AccountMode.fbeExtra + this.CommissionLogin.fbeExtra + this.FeePercent.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingMasterAccountSorting.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 164
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllocationMethod.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FeePercent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!SocialTradingMasterAccountSorting} fbeValue Default value, defaults is new SocialTradingMasterAccountSorting()
   * @returns {!SocialTradingMasterAccountSorting} SocialTradingMasterAccountSorting value
   */
  get (fbeValue = new SocialTradingMasterAccountSorting()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!SocialTradingMasterAccountSorting} fbeValue SocialTradingMasterAccountSorting value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) <= fbeStructSize) {
      fbeValue.AllocationMethod = this.AllocationMethod.get()
    } else {
      fbeValue.AllocationMethod = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMode = this.AccountMode.get()
    } else {
      fbeValue.AccountMode = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionLogin = this.CommissionLogin.get()
    } else {
      fbeValue.CommissionLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) <= fbeStructSize) {
      fbeValue.FeePercent = this.FeePercent.get()
    } else {
      fbeValue.FeePercent = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {!SocialTradingMasterAccountSorting} fbeValue SocialTradingMasterAccountSorting value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingMasterAccountSorting}
   * @param {SocialTradingMasterAccountSorting} fbeValue SocialTradingMasterAccountSorting value
   */
  setFields (fbeValue) {
    this.AllocationMethod.set(fbeValue.AllocationMethod)
    this.AccountMode.set(fbeValue.AccountMode)
    this.CommissionLogin.set(fbeValue.CommissionLogin)
    this.FeePercent.set(fbeValue.FeePercent)
  }
}

export { FieldModelSocialTradingMasterAccountSorting };

/**
 * Fast Binary Encoding SocialTradingMasterAccountSorting model
 */
class SocialTradingMasterAccountSortingModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingMasterAccountSorting(this.buffer, 4)
  }

  /**
   * Get the SocialTradingMasterAccountSorting model
   * @this {!SocialTradingMasterAccountSortingModel}
   * @returns {!FieldModelSocialTradingMasterAccountSorting} model SocialTradingMasterAccountSorting model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingMasterAccountSortingModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingMasterAccountSortingModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingMasterAccountSortingModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingMasterAccountSortingModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingMasterAccountSorting.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingMasterAccountSortingModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingMasterAccountSortingModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingMasterAccountSortingModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingMasterAccountSortingModel}
   * @param {!SocialTradingMasterAccountSorting} value SocialTradingMasterAccountSorting value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingMasterAccountSortingModel}
   * @param {!SocialTradingMasterAccountSorting} value SocialTradingMasterAccountSorting value, defaults is new SocialTradingMasterAccountSorting()
   * @return {!object} Deserialized SocialTradingMasterAccountSorting value and its size
   */
  deserialize (value = new SocialTradingMasterAccountSorting()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingMasterAccountSorting(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingMasterAccountSorting(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingMasterAccountSortingModel}
   * @param {!number} prev Previous SocialTradingMasterAccountSorting model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingMasterAccountSortingModel };
